import React from 'react';
import { Lock } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/Card';

interface PrivacySettingsProps {
  showEmail: boolean;
  showPhone: boolean;
  showSkills: boolean;
  showAchievements: boolean;
  onInputChange: (field: string, value: boolean) => void;
  t: (key: string) => string;
}

const PrivacySettings: React.FC<PrivacySettingsProps> = ({
  showEmail,
  showPhone,
  showSkills,
  showAchievements,
  onInputChange,
  t
}) => {
  return (
    <Card>
      <CardContent className="p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Lock className="w-5 h-5 me-2" />
          {t('Visibility Settings')}
        </h2>

        <p className="text-sm text-muted-foreground mb-4">
          {t('Choose which information to display on your public profile')}
        </p>

        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 border border-border rounded-lg hover:bg-muted transition-colors">
            <span className="text-sm text-muted-foreground">{t('Show Email')}</span>
            <input
              type="checkbox"
              checked={showEmail}
              onChange={(e) => onInputChange('showEmail', e.target.checked)}
              className="w-4 h-4 text-primary rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary"
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-border rounded-lg hover:bg-muted transition-colors">
            <span className="text-sm text-muted-foreground">{t('Show Phone')}</span>
            <input
              type="checkbox"
              checked={showPhone}
              onChange={(e) => onInputChange('showPhone', e.target.checked)}
              className="w-4 h-4 text-primary rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary"
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-border rounded-lg hover:bg-muted transition-colors">
            <span className="text-sm text-muted-foreground">{t('Show Skills')}</span>
            <input
              type="checkbox"
              checked={showSkills}
              onChange={(e) => onInputChange('showSkills', e.target.checked)}
              className="w-4 h-4 text-primary rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary"
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-border rounded-lg hover:bg-muted transition-colors">
            <span className="text-sm text-muted-foreground">{t('Show Achievements')}</span>
            <input
              type="checkbox"
              checked={showAchievements}
              onChange={(e) => onInputChange('showAchievements', e.target.checked)}
              className="w-4 h-4 text-primary rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PrivacySettings;
